module.exports = __webpack_public_path__ + "static/media/no_network.17bbee27.svg";